"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _styles = require("@material-ui/core/styles");
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _Truncate = _interopRequireDefault(require("../Truncate"));
var _LinkWrapper = _interopRequireDefault(require("../RelatedContentCard/LinkWrapper"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _link;
  return {
    mobileBottomControls: {
      width: 105,
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      bottom: -44,
      justifyContent: 'space-between',
      '& > p': {
        margin: 0
      }
    },
    icon: {
      fontSize: theme.typography.pxToRem(24),
      color: theme.palette.primary.main,
      width: '1em'
    },
    iconDisabled: {
      color: theme.palette.grey[500]
    },
    itemWrapper: {
      padding: theme.spacing(0, 4),
      '&:focus': {
        outline: 'none'
      }
    },
    itemTitle: {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      margin: '0',
      color: theme.palette.secondary.main,
      wordBreak: 'break-word',
      '& p': {
        marginBottom: 0
      }
    },
    itemDescription: {
      wordBreak: 'break-word',
      '& p': {
        marginBottom: 0
      }
    },
    imageHeight: {
      position: 'relative',
      overflow: 'hidden',
      background: 'transparent',
      height: 0,
      paddingBottom: '60.7%',
      // ideal size of 290x176
      marginBottom: theme.spacing(3)
    },
    imgResponsive: {
      width: '100%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      objectFit: 'cover'
    },
    error: {
      padding: theme.spacing(6, 5, 3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    },
    text: (0, _defineProperty2.default)({
      lineHeight: theme.typography.pxToRem(16),
      fontSize: theme.typography.pxToRem(14),
      display: 'block'
    }, theme.breakpoints.up('md'), {
      lineHeight: theme.typography.pxToRem(22),
      paddingTop: theme.spacing(1),
      fontSize: theme.typography.pxToRem(16)
    }),
    link: (_link = {
      color: 'inherit',
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(0)
    }, (0, _defineProperty2.default)(_link, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(16),
      marginBottom: theme.spacing(0.5)
    }), (0, _defineProperty2.default)(_link, "fontWeight", theme.typography.fontWeightBold), _link),
    cardElement: {
      display: 'flex',
      margin: 0,
      '& figcaption': {
        color: theme.palette.common.black,
        marginLeft: '1.5rem',
        fontWeight: theme.typography.fontWeightMedium,
        '& p': {
          marginBottom: 0
        }
      }
    },
    mainContentImage: {
      flexShrink: 0,
      width: '88px',
      border: "1px solid ".concat(theme.palette.grey[400]),
      height: '88px',
      overflow: 'hidden',
      textAlign: 'center',
      borderRadius: '4px',
      backgroundColor: theme.palette.common.white,
      display: 'inline-flex',
      '& > img': {
        width: '100%',
        objectFit: 'contain'
      }
    },
    productNameP: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: '1.25'
    },
    productNumP: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
      '& + span': {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightRegular,
        wordBreak: 'break-all'
      }
    },
    btnWrap: {
      marginTop: theme.spacing(8),
      '& button': {
        width: '100%',
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: '1rem'
      }
    }
  };
});
var HeroProductVariation = function HeroProductVariation(_ref) {
  var arialabel = _ref.arialabel,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    delay = _ref.delay,
    autopauseDisabled = _ref.autopauseDisabled,
    _ref$relatedProductDa = _ref.relatedProductData,
    relatedProductData = _ref$relatedProductDa === void 0 ? [] : _ref$relatedProductDa,
    maxRelatedProductCount = _ref.maxRelatedProductCount,
    hideProductImg = _ref.hideProductImg,
    hideProductDesc = _ref.hideProductDesc,
    IMAGE_HOST = _ref.IMAGE_HOST,
    _ref$externalLinks = _ref.externalLinks,
    externalLinks = _ref$externalLinks === void 0 ? [] : _ref$externalLinks,
    PRODUCT_IMAGE_FALLBACK = _ref.PRODUCT_IMAGE_FALLBACK,
    getFallbackImg = _ref.getFallbackImg;
  var classes = useStyles();
  return __jsx(_react.default.Fragment, null, __jsx(_nukaCarousel.default, {
    "aria-label": arialabel,
    cellSpacing: 24,
    autoplay: autoplay,
    autoplayInterval: delay,
    pauseOnHover: !autopauseDisabled,
    slidesToShow: 2,
    slidesToScroll: 2,
    renderBottomCenterControls: function renderBottomCenterControls(props) {
      var previousDisabled = props.currentSlide === 0;
      var nextDisabled = props.currentSlide + props.slidesToShow === props.slideCount || props.slideCount < props.slidesToShow;
      return __jsx("div", {
        className: classes.mobileBottomControls
      }, __jsx(_core.ButtonBase, {
        disabled: previousDisabled,
        onClick: function onClick() {
          return props.previousSlide();
        },
        "aria-label": "previous"
      }, __jsx(_KeyboardArrowLeft.default, {
        className: (0, _clsx3.default)(classes.icon, (0, _defineProperty2.default)({}, classes.iconDisabled, previousDisabled))
      })), __jsx(_core.Typography, {
        variant: "body2"
      }, props.currentSlide + 1, " of ", props.slideCount), __jsx(_core.ButtonBase, {
        disabled: nextDisabled,
        onClick: function onClick() {
          return props.nextSlide();
        },
        "aria-label": "next"
      }, __jsx(_KeyboardArrowRight.default, {
        className: (0, _clsx3.default)(classes.icon, (0, _defineProperty2.default)({}, classes.iconDisabled, props.slidesToScroll && nextDisabled))
      })));
    },
    renderCenterRightControls: function renderCenterRightControls(props) {
      return null;
    },
    renderCenterLeftControls: function renderCenterLeftControls(props) {
      return null;
    }
  }, relatedProductData.slice(0, maxRelatedProductCount).map(function (product, index) {
    var _product$brand;
    var productName = __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: product.name
      }
    });
    var brandName = __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: product === null || product === void 0 ? void 0 : (_product$brand = product.brand) === null || _product$brand === void 0 ? void 0 : _product$brand.name
      }
    });
    // Removing fallback as per STRAT-17307
    // Todo: add a description fallback for author view
    return __jsx("div", {
      key: index,
      className: classes.itemWrapper
    }, __jsx(_react.default.Fragment, null, __jsx(_LinkWrapper.default, {
      href: '/product/' + product.brand.key + '/' + product.productNumber
    }, __jsx("figure", {
      className: classes.cardElement
    }, !hideProductImg && __jsx("div", {
      className: classes.mainContentImage
    }, __jsx("img", {
      src: product.images[0].mediumUrl ? "".concat(IMAGE_HOST).concat(product.images[0].mediumUrl) : product.defaultSrc ? product.defaultSrc : getFallbackImg(product.brand.key),
      onError: function onError(e) {
        ;
        e.target.src = PRODUCT_IMAGE_FALLBACK;
      },
      alt: product.images[0].altText,
      title: product.images[0].altText
    })), __jsx("figcaption", null, brandName && __jsx(_core.Typography, {
      className: classes.productNameP
    }, brandName), (product === null || product === void 0 ? void 0 : product.productNumber) && __jsx(_core.Typography, {
      className: classes.productNumP
    }, product === null || product === void 0 ? void 0 : product.productNumber), productName && __jsx(_Truncate.default, {
      lines: 2
    }, productName)))), __jsx("div", {
      className: classes.btnWrap
    }, __jsx(_core.Button, {
      onClick: function onClick() {
        return alert('Pricing not available in Authoring Environment');
      },
      variant: "outlined",
      color: "primary"
    }, "View Price and Availability"))));
  })));
};
var _default = HeroProductVariation;
exports.default = _default;